import {
  useNavigate,
  useLocation,
  useParams,
  useSearchParams as useRouterSearchParams,
} from "react-router-dom";

export function useRouter() {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useRouterSearchParams();

  return {
    push: (href: string) => navigate(href),
    replace: (href: string) => navigate(href, { replace: true }),
    back: () => navigate(-1),
    forward: () => navigate(1),
    refresh: () => window.location.reload(),
    pathname: location.pathname,
    query: Object.fromEntries(searchParams.entries()),
    asPath: location.pathname + location.search,
    isReady: true,
    events: {
      on: () => {},
      off: () => {},
      emit: () => {},
    },
  };
}

// Custom hook to provide Next.js-like useSearchParams interface
export function useSearchParams() {
  const [searchParams] = useRouterSearchParams();

  return {
    get: (key: string) => searchParams.get(key),
    getAll: (key: string) => searchParams.getAll(key),
    has: (key: string) => searchParams.has(key),
    forEach: (
      callback: (value: string, key: string, parent: URLSearchParams) => void
    ) => searchParams.forEach(callback),
    keys: () => searchParams.keys(),
    values: () => searchParams.values(),
    entries: () => searchParams.entries(),
    toString: () => searchParams.toString(),
    size: searchParams.size,
    routerSearchParams: searchParams,
  };
}

export { useParams };
